import React from 'react';
import { MdMilitaryTech, MdClose } from 'react-icons/md';
import { BadgeIcon } from './badgeData';

export function SeeAllBadgesModal({ badges, onClose, onBadgeClick }) {
  const earnedBadges = badges.filter(b => b.earned);
  const unearnedBadges = badges.filter(b => !b.earned);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] shadow-xl overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center p-4 border-b bg-gradient-to-r from-primary/10 to-secondary/10">
          <h4 className="text-xl font-bold text-gray-800 font-rubik flex items-center gap-2">
            <MdMilitaryTech className="text-yellow-500 text-2xl" />
            All Badges ({earnedBadges.length}/{badges.length})
          </h4>
          <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-full transition-colors">
            <MdClose className="text-gray-500 text-xl" />
          </button>
        </div>

        <div className="p-4 overflow-y-auto max-h-[calc(80vh-80px)]">
          {earnedBadges.length > 0 && (
            <div className="mb-6">
              <p className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3 font-rubik flex items-center gap-2">
                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                Earned ({earnedBadges.length})
              </p>
              <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
                {earnedBadges.map((badge) => (
                  <div
                    key={badge.id}
                    className="relative group p-2 rounded-lg border-2 bg-gradient-to-br from-white to-gray-50 hover:shadow-md transition-all cursor-pointer"
                    style={{ borderColor: badge.color + '40' }}
                    onClick={(e) => onBadgeClick(badge, e)}
                    data-testid={`all-badge-${badge.id}`}
                  >
                    <div className="flex flex-col items-center text-center">
                      <div 
                        className="w-10 h-10 rounded-full flex items-center justify-center mb-1"
                        style={{ backgroundColor: badge.color + '20' }}
                      >
                        <BadgeIcon icon={badge.icon} color={badge.color} size={22} earned={true} />
                      </div>
                      <p className="text-xs font-semibold text-gray-800 font-rubik leading-tight line-clamp-2">
                        {badge.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {unearnedBadges.length > 0 && (
            <div>
              <p className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3 font-rubik flex items-center gap-2">
                <span className="w-2 h-2 bg-gray-400 rounded-full"></span>
                Locked ({unearnedBadges.length})
              </p>
              <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
                {unearnedBadges.map((badge) => (
                  <div
                    key={badge.id}
                    className="relative group p-2 rounded-lg border border-gray-200 bg-gray-50 opacity-70 hover:opacity-100 transition-all cursor-pointer"
                    onClick={(e) => onBadgeClick(badge, e)}
                    data-testid={`all-badge-locked-${badge.id}`}
                  >
                    <div className="flex flex-col items-center text-center">
                      <div className="w-10 h-10 rounded-full flex items-center justify-center mb-1 bg-gray-200">
                        <BadgeIcon icon={badge.icon} color={badge.color} size={22} earned={false} />
                      </div>
                      <p className="text-xs font-semibold text-gray-500 font-rubik leading-tight line-clamp-2">
                        {badge.name}
                      </p>
                      {badge.progress !== undefined && badge.progress > 0 && (
                        <div className="w-full mt-1">
                          <div className="h-1 bg-gray-300 rounded-full overflow-hidden">
                            <div 
                              className="h-full rounded-full"
                              style={{ width: `${badge.progress}%`, backgroundColor: badge.color }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
